import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-74f38122"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "90%",
    "margin-left": "5%"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "float": "right"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "col_bblue"
};
const _hoisted_4 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "flex-direction": "column"
  }
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_6 = {
  key: 1,
  style: {
    "margin": "20px 0 0 10px",
    "color": "#D9001B",
    "display": "flex"
  }
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 补充备注: ", -1));

const _hoisted_8 = {
  style: {
    "margin-left": "5%",
    "width": "80%",
    "word-wrap": "break-word"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_image = _resolveComponent("el-image");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [$props.dpt.status && $props.dpt.status != '1' && $props.dpt.status != '5' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$props.dpt.status == '2' ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 审核中 ")) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass($options.getClassByStatus($data.dataInfo.answerVo.checkStatus))
  }, _toDisplayString($data.dataInfo.answerVo.checkStatusName), 3))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass($data.dataInfo.isEssential ? 'star' : ''),
    style: {
      "font-weight": "bold",
      "margin-bottom": "10px",
      "font-size": "14px",
      "word-wrap": "break-word"
    }
  }, _toDisplayString($props.listIndex) + "." + _toDisplayString($data.dataInfo.title || '标题'), 3), _createElementVNode("div", null, [!$props.isCheckBox ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataInfo.itemList, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_tooltip, {
      class: "item",
      effect: "dark",
      content: item.optionName,
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass($props.isCheckBox ? [$data.selectsIndex[index] ? 'optionSelect' : 'option'] : [$data.selectIndex === item.id ? 'optionSelect' : 'option']),
        style: {
          "height": "22px",
          "max-width": "100px",
          "overflow": "hidden",
          "text-overflow": "ellipsis",
          "white-space": "nowrap"
        }
      }, _toDisplayString(item.optionName), 3)]),
      _: 2
    }, 1032, ["content"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.damageReportContentItemImageList, imgItems => {
      return _openBlock(), _createElementBlock(_Fragment, null, [imgItems.imageUrl ? (_openBlock(), _createBlock(_component_el_image, {
        key: 0,
        class: "avatarPreview m_0_5",
        src: $options.replacePath(imgItems.imageUrl),
        "preview-src-list": $data.imgArray,
        style: {},
        fit: "cover"
      }, null, 8, ["src", "preview-src-list"])) : _createCommentVNode("", true)], 64);
    }), 256))]);
  }), 256))])) : _createCommentVNode("", true)]), $data.dataInfo.answerVo?.checkStatus === '1' && $props.dpt.status != '2' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString($data.dataInfo.answerVo.checkRemark), 1)])) : _createCommentVNode("", true)])]);
}